"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-restricted-syntax */
const RestError_1 = __importDefault(require("./RestError"));
class NetworkRestError extends RestError_1.default {
    /**
     *
     * @param message Basic Error Message
     * @param options We can attach any extra info/properties for this error
     */
    constructor(message, options = {}) {
        super(message);
        for (const [key, value] of Object.entries(options)) {
            this[key] = value;
        }
    }
}
exports.default = NetworkRestError;
//# sourceMappingURL=NetworkRestError.js.map